import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getAllCatelogueSeller } from "../../../../../redux/action/catalogue";
import SellerCatelogueTable from "../catalogue/SellerCatelogueTable";
import { useState } from "react";

function CatelogueInSeller({ auctionStatus = false }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [catalogueList, setCatalogueList] = useState([]);
  const { CatelogueLoading, allSellerCatelogue } = useSelector(
    (state) => state.catelogueData
  );

  function convertObjectToArray(obj) {
    if (Object.keys(obj).length === 0) {
      return [];
    }

    return [obj];
  }

  useEffect(() => {
    dispatch(getAllCatelogueSeller(id));
  }, [dispatch, id]);

  useEffect(() => {
    const arrayObjOfCatalogue = convertObjectToArray(allSellerCatelogue);
    setCatalogueList(arrayObjOfCatalogue);
  }, [allSellerCatelogue]);

  return (
    <SellerCatelogueTable
      catalogueList={catalogueList}
      CatelogueLoading={CatelogueLoading}
      auctionStatus={auctionStatus}
    />
  );
}

export default CatelogueInSeller;
